<template>
  <div>
    <dx-data-grid ref='refMonthPlan'
      :data-source='planInfoList'
      :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
      :hover-state-enabled = "true" :allowColumnResizing = 'true'
      column-resizing-mode = 'widget' :allow-column-reordering = "true"
      :height='gridHeight' :row-alternation-enabled="true"
      :focused-row-enabled="true"
      :focused-row-key.sync='focusedRowKey'
      :auto-navigate-to-focused-row="true"
      key-expr="품번"
      @toolbar-preparing='onToolbarPreparing'
      @row-updated='onRowUpdatedPlan'
      @cellPrepared='onCellPreparedPlan'
    >
      <DxSearchPanel
        :visible="true"
        placeholder="검색..."
      />
      <DxExport
        :enabled="true"
        :file-name="selectedMonth"
      />
      <DxKeyboardNavigation
        :edit-on-key-press="true"
        enter-key-action="moveFocus"
        enter-key-direction="row"
      />
      <DxFilterRow
        :visible="true"
        apply-filter="auto"
      />
      <DxEditing
        :allow-deleting="false"
        :allow-updating="checkEditablePlan"
        :allow-adding="false"
        :use-icons="true"
        mode='batch'
      >
      </DxEditing>
      <DxColumnFixing :enabled="true"/>
      <DxColumn
        :allowEditing='false'
        caption="고객사"
        data-field="납품처코드"
        :visible='true'
        sort-order="asc"
      >
          <DxLookup
          :data-source="customerLookup"
          display-expr="거래처명"
          value-expr="거래처코드"
        />
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        sort-order='asc'
        caption="차종"
        data-field="차종"
        width="80"
      >
        <DxLookup
          :data-source="carTypeLookup"
          display-expr="모델명"
          value-expr="모델코드"
        />
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        sort-order='asc'
        caption="품번"
        data-field="품번"
      >
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        caption="품명"
        data-field="품명"
      >
      </DxColumn>
      <DxColumn
        :allowEditing='true'
        format ='#,##0'
        caption="월생산계획"
        dataType="number"
        data-field="월합계"
      >
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        caption="품목유형"
        data-field="품목유형"
        :visible='true'
      >
        <DxLookup
          :data-source="itemTypeLookup"
          display-expr="코드명"
          value-expr="코드"
        />
      </DxColumn>
      <DxColumn
          :allowEditing='false'
          caption="공정유형"
          data-field="공정유형"
          :visible='true'
        >
        <DxLookup
          :data-source="processingTypeLookup"
          display-expr="코드명"
          value-expr="코드"
        />
      </DxColumn>
       <DxColumn
          :allowEditing='false'
          caption="자재유형"
          data-field="자재유형"
          :visible='true'
        >
          <DxLookup
            :data-source="materialTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
      <!-- <DxColumn
        :caption="selectedMonth"
        alignment='center'
      >
        <DxColumn v-for='(item, index)  in  dateArray' :key="index"
          :caption = item.caption
          :data-field = item.dataField
          :data-type = item.dataType
          :format = item.format
          :allow-sorting="false"
        />
      </DxColumn> -->
      <DxSummary>
        <DxTotalItem
            value-format='#,##0'
            show-in-column="거래처코드"
            display-format="{0} (건)"
          />
        <DxTotalItem
          value-format='#,##0'
          column="합계"
          summary-type="sum"
          display-format="{0}"
        />
      </DxSummary>
      <dx-paging :enabled="false"/>
      <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
      <dx-sorting mode="multiple"/>
    </dx-data-grid>
    <DxPopup2 v-if="addPlanItem"
      :visible.sync="addPlanItem"
      :width="600"
      :height="220"
      title="월계획 품목 추가"
    >
      <div>
        <DxForm2
          ref="refFormAddItem"
          id="form"
          :on-content-ready="validateForm"
          :col-count="2"
          :form-data.sync="addPlanItemSource"
        >
          <DxItem
            data-field="계획년월"
            editor-type="dxTextBox"
            :editor-options ="{ disabled: true}"
          />
          <DxItem
            data-field="차종"
            editor-type="dxSelectBox"
            :editor-options = "carModelOption"
          >
            <dx-required-rule message="항목을 입력하세요"/>
          </DxItem>

          <DxItem
            data-field="고객사"
            editor-type="dxSelectBox"
            :editor-options = "customerOption"
          >
            <dx-required-rule message="항목을 입력하세요"/>
          </DxItem>
          <DxItem
            data-field="품번"
            template="productionGridTemplate"
          >
            <dx-required-rule message="항목을 입력하세요"/>
          </DxItem>
          <DxItem
            data-field="생산수량"
            editor-type="dxTextBox"
          >
            <dx-required-rule message="항목을 입력하세요"/>
          </DxItem>
          <DxEmptyItem />
          <DxEmptyItem />
          <DxEmptyItem />
          <DxButtonItem
            :col-span="2"
            :button-options="buttonOptions"
            horizontal-alignment="right"
          />
          <template #productionGridTemplate="{ data: cellInfo }">
              <ProductionGridComponent
                ref="refProductGrid"
                option="품번"
                :value="cellInfo.value"
                :onValueChanged="cellInfo.setValue"
                @selected-pcode='setProductionCode'
                :productionInfo='productionList'
                :isEdit="true"
              />
            </template>
        </DxForm2>
      </div>
    </DxPopup2>
  </div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem, DxSummary, DxKeyboardNavigation,
  DxColumn, DxPaging, DxSorting, DxEditing, DxSearchPanel, DxLookup } from 'devextreme-vue/data-grid'
import HttpService from '../../share/service/HttpService'
import { DxForm as DxForm2, DxItem, DxButtonItem, DxEmptyItem } from 'devextreme-vue/form'
import { DxPopup as DxPopup2 } from 'devextreme-vue/popup'
import { DxRequiredRule } from 'devextreme-vue/validator'
import ProductionGridComponent from '../../share/component/ProductionGridComponent.vue'

export default {
  name: 'MonthPlanComponent',
  data: function () {
    return {
      isLoading: false,
      yearArray: [],
      thisYear: null,
      monthArray: [],
      thisMonth: null,
      monthDay: null,
      selectedMonth: null,
      dateArray: null,
      planInfoList: [],
      timerId: null,
      updateMode: false,
      customerLookup: null,
      focusedRowKey: null,
      itemTypeLooku: null,
      processingTypeLookup: null,
      materialTypeLookup: null,
      // item add popup
      addPlanItem: false,
      productionList: null,
      deliveryData: null,
      carModelOption: null,
      carTypeLookup: null,
      customerOption: null,
      buttonOptions: {
        text: '저장',
        width: 120,
        type: 'default',
        onClick: (args) => {
          this.onSaveButton()
        }
      },
      selectedProductionCode: null,
      addPlanItemSource: null
    }
  },
  props: {
    gridHeight: {
      type: Number,
      default: null
    }

  },
  computed: {
    checkEditablePlan () {
      // const planMonth = `${this.thisYear}-${this.thisMonth}-01`
      // const today = AppLib.getToday()
      // if (planMonth < today) {
      //   return false
      // }
      return true
    }
  },
  components: {
    DxDataGrid,
    DxExport,
    DxFilterRow,
    DxColumnFixing,
    DxColumn,
    DxPaging,
    DxSorting,
    DxEditing,
    DxSearchPanel,
    DxLookup,
    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxKeyboardNavigation,
    DxForm2,
    DxItem,
    DxButtonItem,
    DxEmptyItem,
    DxPopup2,
    DxRequiredRule,
    ProductionGridComponent
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.processingTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
    this.materialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.monthDay = AppLib.getMonthLastDay(this.thisYear, this.thisMonth)
    this.customerLookup = this.$store.getters.getCustomerInfo
    this.customerLookup = this.$_.sortBy(this.customerLookup, '거래처명')
    this.carTypeLookup = this.$store.getters.getCarType
    console.log(this.carTypeLookup)
    this.carModelOption = {
      items: this.carTypeLookup,
      valueExpr: '모델코드',
      displayExpr: '모델명'
    }
    this.customerOption = {
      items: this.customerLookup,
      valueExpr: '거래처코드',
      displayExpr: '거래처명'
    }
    // this.refreshMonthPlan(`${this.thisYear}-${this.thisMonth}-01`)
  },
  mounted () {

  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onCellPreparedPlan (e) {
      if (e.rowType === 'data' && e.column.dataField === '월합계') {
        this.$Q(e.cellElement).css('color', 'blue')
      }
    },
    onRowUpdatedPlan (row) {
      console.log(row)
      if (this.timerId !== null) {
        clearTimeout(this.timerId)
      }

      let saveInfo = this.$Q.extend(true, {}, row.data)
      saveInfo.생산계획 = JSON.stringify(saveInfo)
      saveInfo.계획연월 = `${this.thisYear}-${this.thisMonth}-01`
      saveInfo.updateid = this.userInfo.userId
      saveInfo.updatetime = AppLib.getNow()
      // saveInfo.월합계 = 0
      for (let i = 0; i < this.monthDay; i++) {
        if (row.data[`${i + 1}`] !== undefined) {
          saveInfo.월합계 += row.data[`${i + 1}`]
        }
      }
      // console.log(saveInfo)
      this.isLoading = true
      this.$_sp.runUpdateProc('spUpdateMonthPlan', [saveInfo])
        .then((data) => {
          this.isLoading = false
          HttpService.reqPostBody(this.$_sp.makeParamModel({ 계획연월: `${this.thisYear}-${this.thisMonth}-01` }), '/saveProductWeekPlan')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '품목추가',
            icon: 'plus',
            text: '품목추가',
            type: 'default',
            focusStateEnabled: false,
            disabled: false,
            onClick: (args) => {
              this.addPlanItemSource = {
                차종: null,
                품번: null,
                고객사: null,
                품명: null,
                계획년월: `${this.thisYear}년 ${this.thisMonth}월`,
                생산수량: null
              }
              this.refreshProduction()
            }
          }
        }
      )
    },
    refreshMonthPlan (month) {
      console.log('refreshMonthPlan', month)
      this.thisYear = month.substring(0, 4)
      this.thisMonth = month.substring(5, 7)
      this.isLoading = true
      this.planInfoList = []
      this.selectedMonth = `${month.substring(0, 7)}월 생산계획`
      this.$_sp.runNoEncodeFindProc('spFindAllMonthPlanByMonth', { 계획연월: month })
        .then((data) => {
          this.planInfoList = this.$_sp.MakeModel(data)
          // console.log(this.planInfoList)
          this.isLoading = false
          // this.updateMode = false
          // for (let j = 0; j < temp.length; j++) {
          //   if (temp[j].생산계획 !== null) {
          //     this.updateMode = true
          //   }
          // }
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // ********************* 품목추기 팝업 *********************
    onSaveButton (e) {
      if (!this.$refs.refFormAddItem.instance.validate().isValid) return
      if (this.$_.findIndex(this.planInfoList, { 품번: this.addPlanItemSource.품번 }) >= 0) {
        this.$snotify.warning('이미 등록된 품번 입니다.')
        return
      }
      console.log(this.addPlanItemSource)
      let param = {
        createid: this.userInfo.userId,
        updateid: this.userInfo.userId,
        createtime: AppLib.getNow(),
        updatetime: AppLib.getNow(),
        계획연월: `${this.thisYear}-${this.thisMonth}-01`,
        납품처코드: this.addPlanItemSource.고객사,
        생산계획: null,
        월합계: this.addPlanItemSource.생산수량,
        품명: this.addPlanItemSource.품명,
        품번: this.addPlanItemSource.품번,
        차종: this.addPlanItemSource.차종,
        품목유형: this.$_.findWhere(this.productionList, { 품번: this.addPlanItemSource.품번 }).품목유형,
        공정유형: this.$_.findWhere(this.productionList, { 품번: this.addPlanItemSource.품번 }).공정유형,
        자재유형: this.$_.findWhere(this.productionList, { 품번: this.addPlanItemSource.품번 }).자재유형
      }
      const temp = {}
      for (let i = 0; i < this.monthDay; i++) {
        temp[`${i + 1}`] = null
      }
      temp.차종 = this.addPlanItemSource.차종
      temp.사양 = 'ALL'
      param.생산계획 = JSON.stringify(temp)
      this.planInfoList.push(param)
      this.addPlanItem = false
      this.focusedRowKey = this.addPlanItemSource.품번
      this.$_sp.runUpdateProc('spSaveMonthPlanAddItem', [param])
        .then(data => {

        })
    },
    refreshProduction () {
      if (this.productionList !== null) {
        this.addPlanItem = true
        return
      }
      this.isLoading = true
      this.$_sp.runNoEncodeFindSqlProc('품목정보', null)
        .then((data) => {
          this.productionList = this.$_sp.MakeModel(data)
          this.isLoading = false
          this.addPlanItem = true
        })
    },
    setProductionCode (code) {
      this.selectedProductionCode = code
      this.addPlanItemSource.품명 = this.$_.findWhere(this.productionList, { 품번: code }).품명
      this.addPlanItemSource.품번 = code
    },
    validateForm (e) {
      // e.component.validate()
    }

  }
}
</script>

<style lang="scss">
.mrp-wrap {
  margin-top: 10px;
  overflow: hidden;
}
</style>
